import AbstractChart from './AbstractChart';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import moment from 'moment';
import {
  CHART_BACKGROUND_COLOUR,
  DEFAULT_CHART_HEIGHT,
  DEFAULT_CHART_WIDTH,
  FILTER_DATE_RANGE_FORMAT,
  DEFAULT_TITLE_STYLE,
  DEFAULT_NO_DATA_OPTIONS,
  SERIES_KEY,
  TITLE_KEY,
  TEXT_KEY
} from './constants/HighchartsConstants';
import { renderChart } from './CommonChartMethods';

class SpiderChart extends AbstractChart{
  constructor(props) {
    super(props);
    this.state = {
      filterDateRange: {
        fromDate: moment().format(FILTER_DATE_RANGE_FORMAT),
        toDate: moment().format(FILTER_DATE_RANGE_FORMAT),
      },
      chartData: [],
      source: [],
      mapDataFromProps: [],
      mapOptions: {
        chart: {
          polar: true,
          type: 'area',
          backgroundColor: CHART_BACKGROUND_COLOUR,
          marginBottom: 0,
          marginLeft: 0,
          marginTop: 20,
          width: DEFAULT_CHART_WIDTH,
          height: DEFAULT_CHART_HEIGHT,
        },
        series: [],
        legend: {
          enabled: false,
        },
        pane: {
          size: '80%',
        },
        title: {...DEFAULT_TITLE_STYLE},
        tooltip: { enabled: false },
        credits: {
          enabled: false,
        },
        noData: {...DEFAULT_NO_DATA_OPTIONS},
        xAxis: {
          tickmarkPlacement: 'on',
          lineWidth: 0,
          categories: [],
          labels: {
            style: {
              color: '#999999',
              fontSize: '10px',
              lineHeight: '5px',
              textTransform: 'capitalize',
            },
          },
        },
        yAxis: {
          gridLineInterpolation: 'polygon',
          lineWidth: 0,
          tickInterval: 0.2,
          min: 0,
          labels: {
            enabled: false,
          },
          title: '',
        },
      },
    };
  }

  parseSpiderChart = chart => {
    return {
      categories: chart.categories,
      values: [
        {
          data: chart['values'],
          pointPlacement: 'on',
          color: '#2699FB',
          marker: {
            enabled: false,
          },
        },
      ],
    };
  };
  reRenderChartOnChange = props => {
    let { mapOptions } = this.state;
    const { retrieveSelectedChartData } = this.props.actions;
    this.setState(
      {
        mapOptions,
        filterDateRange: props.dateRangeFilterValue,
        source: props.source,
        topicId: props.selectedTopicId,
      },
      () => {
        retrieveSelectedChartData({
          chartId: this.props.chartId.replace('chart', ''),
          dateFilterValue: this.state.filterDateRange,
          topicId: this.state.topicId,
          source: this.state.source,
        });
      },
    );
  };

  componentDidMount() {
    this.reRenderChartOnChange(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { chartId, selectedTopicId, source } = this.props;
    if (
      JSON.stringify(newProps.SpiderChart[chartId]) !==
        JSON.stringify(this.state.mapDataFromProps) &&
      newProps.selectedTopicId.length
    ) {
      this.setState({ chartData: [] });

      const { title } = this.props;
      const chartData = this.parseSpiderChart(newProps.SpiderChart[chartId]);

      let { mapOptions } = this.state;
      mapOptions[SERIES_KEY] = chartData['values'];
      mapOptions['xAxis']['categories'] = chartData['categories'];
      mapOptions[TITLE_KEY][TEXT_KEY] = title;
      this.setState({
        chartData,
        mapOptions,
        mapDataFromProps: newProps.SpiderChart[chartId],
        source,
      });
    }

    if (this._shouldReRenderChartBasedOnNewProps(newProps)) {
      this.reRenderChartOnChange(newProps);
    }
  }

  render() {
    const { mapOptions, mapDataFromProps } = this.state;
    return renderChart(mapOptions, mapDataFromProps);
  }
}

function mapStateToProps(state) {
  return {
    SpiderChart: state.charts,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SpiderChart);



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/SpiderChart.js